export default __webpack_public_path__ + "static/media/VERY_FOS.67a69058.pdf";